import { render, staticRenderFns } from "./ProvTradeSend.vue?vue&type=template&id=e8ab19cc&scoped=true&"
import script from "./ProvTradeSend.vue?vue&type=script&lang=js&"
export * from "./ProvTradeSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ab19cc",
  null
  
)

export default component.exports